<div class="view-syllabus-pop-area">
    
    <div class="pophdng-area">
        <span class="popcls-mob-btn" mat-dialog-close>
            <img src="assets/img/back-button.svg" class="popcls-icon" />
        </span>
        <h3>Test Syllabus</h3>
        <span class="popcls-btn" mat-dialog-close><img src="assets/img/filter-close-icon.png" class="popcls-icon" /></span>
    </div>

    <div class="UNFAPP-outerheight_syl">
        <mat-accordion class="view-syllabus-accro">
            <ng-container *ngFor="let syllabus of syllabusDetails; index as i">
                <mat-expansion-panel [expanded]="i == 0 ? true : false">
                    <mat-expansion-panel-header>
                        <div class="syllabus-accro-hdr">
                            <img class="accro-hd-icon" style="height: 25px;
                            width: 24.93px;" src="assets/img/subject-icons/{{getSubIcon(syllabus?.subjectname) | lowercase}}-icon.svg" />
                            <h4 class="syllabus-accro-hdr-title">{{syllabus?.subjectname}}</h4>
                        </div>
                    </mat-expansion-panel-header>
                    <ul class="subtpc-lst">
                        <li *ngFor="let chapters of syllabus?.chapters">{{chapters.chaptername}}</li>
                        <!-- <li>Electricity and conductivity</li>
                        <li>Magnetism</li> -->
                    </ul>
                </mat-expansion-panel>
            </ng-container>

            <!-- <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <div class="syllabus-accro-hdr">
                        <img class="accro-hd-icon" src="assets/img/Chem-solid-icon.svg" />
                        <h4 class="syllabus-accro-hdr-title">Chemistry</h4>
                    </div>
                </mat-expansion-panel-header>
                <ul class="subtpc-lst">
                    <li>Laws of motion</li>
                    <li>Electricity and conductivity</li>
                    <li>Magnetism</li>
                </ul>
            </mat-expansion-panel> -->

            <!-- <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <div class="syllabus-accro-hdr">
                        <img class="accro-hd-icon" src="assets/img/bio-solid-icon.svg" />
                        <h4 class="syllabus-accro-hdr-title">Biology</h4>
                    </div>
                </mat-expansion-panel-header>
                <ul class="subtpc-lst">
                    <li>Laws of motion</li>
                    <li>Electricity and conductivity</li>
                    <li>Magnetism</li>
                </ul>
            </mat-expansion-panel> -->


        </mat-accordion>
    </div>
</div>

